export default {
  groupName: 'adpi-category-qsr',
  appName: 'QSR Category',
  baseRoute: '/dashboard/adpi-category-qsr',
  label: 'Ad Effect Restaurant Dashboard',
  home: '/slicer',
  image: 'marketcast.png',
  description: 'Ad Effect Restaurant Dashboard'
};



// WEBPACK FOOTER //
// ./src/app/configuration/CategoryQSR/config/main.js